import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const SERVICE_CALLS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('SERVICE_CALLS');
export const SERVICE_CALLS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SERVICE_CALLS_CRUD_ACTION_CONSTANTS
);
